import { Tooltip } from 'react-tooltip'

const BaseReactTooltip = ({ 
  children,
  ...props
}) => {
  return (
    <Tooltip {...props}>
      {children}
    </Tooltip>
  )
}

export default BaseReactTooltip